import { Timestamp } from 'firebase/firestore';
import { dbClienti, dbContatti, leggiInfoDBRaw, leggiInfoDB } from "./gestioneDB";
import { ref, toRaw } from "vue";
import ExcelJS from 'exceljs';
import logoUrl from '@/assets/LogoLMC.png';

let screenType = 'largo';
export const schermoLargo = ref(false);
export const mostraInfoSviluppo = ref(false);
export const permettiElimina = ref(false);
export const mostraListiniInattivi = ref(false);
export const ricercaCompleta = ref(false);
export const idVersione = '29/09/2026';
export const numGiorniDocumentiVecchi = ref(2);
export const copiaTrasporto = ref({});  // Contiene dati per fare copia-incolla
export const ultimaVersione = ref({ id: null, descrizione: null });
export const impostazioniGenerali = ref({ prezzoManodopera: 1, ricaricoGenerale: 0, tagsLeads: [] });
export const statoInterfaccia = ref({ elementoVisibile: "Home" });      // Contiene lo stato dell'interfaccia dei vari componenti

export function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve(script);
        script.onerror = () => reject(new Error(`Script load error for ${src}`));
        document.head.append(script);
    });
}

export function setScreen(valoreForzato) {
    if (valoreForzato) {
        screenType = valoreForzato;
    } else {
        screenType = (screen.width > 1023) ? 'largo' : 'stretto';
    }
}

export function tipoSchermo() {
    return screenType;
}

export function checkSize() {
    schermoLargo.value = window.innerWidth > 768;
    //   console.log('window: ' + window.innerWidth);
    //   console.log('checkSize: ' + schermoLargo.value);
}

// inizializza una sola volta
export function initDeviceListener() {
    checkSize();
    window.addEventListener('resize', checkSize);
}

export function dataDaTimestamp(tStamp, formato) {
    // Converte una data di FireStore in una stringa
    // formato: testo = data leggibile - date = data per form - anno = stringa anno
    let tempData = '';
    if (tStamp) {
        let dt = new Date(tStamp.seconds * 1000);
        switch (formato) {
            case 'testoAA-MM':
                tempData = dt.getFullYear() + '-' + (dt.getMonth() + 1).toString().padStart(2, '0');
                break;
            case 'testo':
                tempData = dt.getDate().toString().padStart(2, '0') + '/' + (dt.getMonth() + 1).toString().padStart(2, '0') + '/' + dt.getFullYear();
                break;
            case 'testoAAAA-MM-GG':
                tempData = dt.getFullYear() + '-' + (dt.getMonth() + 1).toString().padStart(2, '0') + '-' + dt.getDate().toString().padStart(2, '0');
                break;
            case 'anno':
                tempData = dt.getFullYear();
                break;
            default:
                tempData = + dt.getFullYear() + '-' + (dt.getMonth() + 1).toString().padStart(2, '0') + '-' + dt.getDate().toString().padStart(2, '0');
        }
    } else {
        tempData = null;
    }
    return tempData;
}

export function codiceCifreFisse(cod, nCifre = 4) {
    return String(cod).padStart(nCifre, '0');
}

export function generaStringaCliente(clID, elmId, elmTipo = 'cliente') {
    // Uscita rapida se mancano i dati fondamentali
    if (!clID || !dbClienti.value[clID]) return '';

    const cliente = dbClienti.value[clID];

    // 1. Costruzione dei blocchi base
    const nomeCognome = [cliente.nome, cliente.cognome].filter(Boolean).join(' ').trim();
    // Usa il valore di default di 4 cifre per il cliente
    const codCliente = cliente.codice ? codiceCifreFisse(cliente.codice) : null;

    // 2. Costruzione dei blocchi specifici (Lavoro/Lead)
    let codElemento = null;
    let oggetto = null;

    if (elmTipo.startsWith('lavoro')) {
        const lav = cliente.lavori?.[elmId];
        if (lav) {
            codElemento = lav.codice ? codiceCifreFisse(lav.codice, 2) : null;
            oggetto = lav.oggetto ? String(lav.oggetto).trim() : null;
        }
    } else if (elmTipo.startsWith('lead')) {
        const ld = cliente.leads?.[elmId];
        if (ld) {
            oggetto = ld.oggetto ? String(ld.oggetto).trim() : null;
        }
    }

    // 3. Assemblaggio dinamico e intelligente
    switch (elmTipo) {
        case 'cliente':
            return [codCliente, nomeCognome].filter(Boolean).join(' - ');

        case 'clienteCorta':
            return nomeCognome;

        case 'lavoro': {
            // Unisce NNNN e LL con un trattino. Se manca NNNN, rimane solo LL.
            const bloccoCodiceLavoro = [codCliente, codElemento].filter(Boolean).join('-');
            return [bloccoCodiceLavoro, nomeCognome, oggetto].filter(Boolean).join(' - ');
        }

        case 'lavoroCorta':
            return [codElemento, oggetto].filter(Boolean).join(' - ');

        case 'lead':
            return [codCliente, nomeCognome, oggetto].filter(Boolean).join(' - ');

        case 'leadCorta':
            return oggetto || '';

        default:
            return [codCliente, nomeCognome].filter(Boolean).join(' - ');
    }
}

export function generaIdContatto() {
    // Cerca e restituisce il primo id libero in dbContatti
    let tempId = 1;
    for (let ct in dbContatti.value) {
        ct = parseInt(ct);
        if (ct >= tempId) {
            tempId = ct + 1;
        }
    }
    return tempId;
}

export function generaIdCliente() {
    // Cerca e restituisce il primo id libero in dbClienti
    let tempId = 1;
    for (let cl in dbClienti.value) {
        cl = parseInt(cl);
        if (cl >= tempId) {
            tempId = cl + 1;
        }
    }
    return tempId;
}

export function generaIdPreventivo() {
    // Cerca e restituisce il primo id libero in dbClienti
    let tempId = 1;
    for (let cl in dbClienti.value) {
        for (let ld in dbClienti.value[cl].leads) {
            for (let pr in dbClienti.value[cl].leads[ld].preventivi) {
                pr = parseInt(pr);
                if (pr >= tempId) {
                    tempId = pr + 1;
                }
            }
        }
    }
    return tempId;
}

export function generaIdDico(idCliente, idLavoro) {
    // Cerca e restituisce il primo id libero nel cliente
    let tempId = 1;
    for (let ee in dbClienti.value[idCliente].lavori[idLavoro].dico) {
        if (ee >= tempId) {
            ee = parseInt(ee);
            tempId = ee + 1;
        }
    }
    return tempId;
}

export function generaIdContabile(idCliente, idLavoro) {
    // Cerca e restituisce il primo id libero nel cliente
    let tempId = 1;
    for (let fs in dbClienti.value[idCliente].lavori[idLavoro].contabili) {
        if (fs >= tempId) {
            fs = parseInt(fs);
            tempId = fs + 1;
        }
    }
    return tempId;
}

export function generaIdFase(idCliente, idLavoro) {
    // Cerca e restituisce il primo id libero nel cliente
    let tempId = 1;
    for (let el in dbClienti.value[idCliente].lavori[idLavoro].fasi) {
        if (el >= tempId) {
            el = parseInt(el);
            tempId = el + 1;
        }
    }
    return tempId;
}

export function generaIdCosto(idCliente, idLavoro) {
    // Cerca e restituisce il primo id libero nel cliente
    let tempId = 1;
    for (let el in dbClienti.value[idCliente].lavori[idLavoro].costi) {
        if (el >= tempId) {
            el = parseInt(el);
            tempId = el + 1;
        }
    }
    return tempId;
}

export function generaIdLead() {
    // Cerca e restituisce il primo id libero per un lead in dbClienti
    let tempId = 1;
    for (let cl in dbClienti.value) {
        for (let ld in dbClienti.value[cl].leads) {
            ld = parseInt(ld);
            if (ld >= tempId) {
                tempId = ld + 1;
            }
        }
    }
    return tempId;
}

export function generaIdLavoro() {
    // Cerca e restituisce il primo id libero per un lavoro in dbClienti
    let tempId = 1;
    for (let cl in dbClienti.value) {
        for (let ll in dbClienti.value[cl].lavori) {
            ll = parseInt(ll);
            if (ll >= tempId) {
                tempId = ll + 1;
            }
        }
    }
    return tempId;
}

export function trovaIdCliente(id, tipo) {
    // Restituisce l'id del cliente di un determinato lavoro o lead
    // tipo = 'lavori', 'leads'
    let tempIdCliente = null;
    for (let cl in dbClienti.value) {
        for (let el in dbClienti.value[cl][tipo]) {
            if (el == id) {
                tempIdCliente = cl;
                return tempIdCliente;
            }
        }
    }
}

export function generaStringa(valore, tipo, zeroVisibile) {
    let tempValore = '';
    switch (tipo) {
        case '0,00':
            if (valore != null && valore != 0 && !isNaN(valore)) {
                tempValore = valore.toLocaleString("it-IT", {
                    notation: "standard",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            } else if (zeroVisibile) {
                tempValore = '0,00'
            }
            break;
        case '%':
            if (valore != null && valore != 0 && !isNaN(valore)) {
                valore = valore * 100;
                tempValore = valore.toLocaleString("it-IT", {
                    notation: "standard",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                });
                tempValore = tempValore + ' %';
            } else if (zeroVisibile) {
                tempValore = '0 %'
            }
            break;
    }
    return tempValore;
}

export function trovaNumeroPreventivo() {
    // Trova il primo numero di preventivo libero < 1000 per l'anno in corso
    const anno = (new Date(Date.now()).getFullYear());
    let nn = 1;
    for (let cl in dbClienti.value) {
        for (let ld in dbClienti.value[cl].leads) {
            for (let pr in dbClienti.value[cl].leads[ld].preventivi) {
                let tempNumP = dbClienti.value[cl].leads[ld].preventivi[pr].numero;
                const annoP = dataDaTimestamp(dbClienti.value[cl].leads[ld].preventivi[pr].data, 'anno');
                if (annoP == anno && tempNumP >= nn && tempNumP < 1000) {
                    nn = tempNumP + 1;
                }
            }
        }
    }
    return nn;
}

export function trovaNumeroDico() {
    // Trova il primo numero di dico libero < 1000 per l'anno in corso
    const anno = (new Date(Date.now()).getFullYear());
    let nn = null;
    for (let cl in dbClienti.value) {
        for (let lv in dbClienti.value[cl].lavori) {
            for (let dc in dbClienti.value[cl].lavori[lv].dico) {
                let tempNumD = dbClienti.value[cl].lavori[lv].dico[dc].numero;
                const annoD = dataDaTimestamp(dbClienti.value[cl].lavori[lv].dico[dc].data, 'anno');
                if (annoD == anno && tempNumD >= nn && tempNumD < 1000) {
                    nn = tempNumD + 1;
                }
            }
        }
    }
    return nn;
}

export function dataCorrenteInversa() {
    const dt = new Date();
    const yy = String(dt.getFullYear());
    const mm = String(dt.getMonth() + 1);
    const dd = String(dt.getDate());
    return yy + "-" + (mm.length != 2 ? "0" + mm : mm) + "-" + (dd.length != 2 ? "0" + dd : dd);
}

export function dataCorrente() {
    const dt = new Date();
    const yy = String(dt.getFullYear());
    const mm = String(dt.getMonth() + 1);
    const dd = String(dt.getDate());
    return (dd.length != 2 ? "0" + dd : dd) + "/" + (mm.length != 2 ? "0" + mm : mm) + "/" + yy;
}

export function apriLinkLuogo(coordinate) {
    const url = "https://www.google.com/maps/place/" + coordinate;
    window.open(url, '_blank');
}

export async function scaricaXlsxContabilita(elencoContabili) {
    if (elencoContabili.length <= 0) {
        return 0;
    } else {
        const wb = new ExcelJS.Workbook();
        const ws = wb.addWorksheet('Contabilità');

        try {
            const response = await fetch(logoUrl);
            const imageBuffer = await response.arrayBuffer();
            const imageId = wb.addImage({
                buffer: imageBuffer,
                extension: 'png',
            });
            ws.addImage(imageId, {
                tl: { col: 0, row: 0 },
                ext: { width: 150, height: 75 }
            });
        } catch (e) {
            console.warn("Impossibile caricare il logo:", e);
        }

        // Aggiungo righe vuote per dare spazio al logo (ad es. 4 righe)
        for (let i = 0; i < 4; i++) {
            ws.addRow([]);
        }

        ws.addRow(['Data: ' + dataCorrente()]);
        ws.addRow(['Cliente: ' + leggiInfoDBRaw(elencoContabili[0]).stringaCliente]);
        ws.addRow(['Lavoro: ' + leggiInfoDBRaw(elencoContabili[0]).stringaLavoro]);
        ws.addRow([]);

        const headerRow = ws.addRow(['Data', 'Causale', 'Preventivo', 'Consuntivo', 'Fattura']);
        // Titoli: grassetto, bordo inferiore sottile, testo centrato per Preventivo, Consuntivo e Fattura
        for (let col = 1; col <= 5; col++) {
            const cell = headerRow.getCell(col);
            cell.font = { bold: true };
            cell.border = { bottom: { style: 'thin', color: { argb: 'FF000000' } } };
            if (col >= 3) {
                cell.alignment = { horizontal: 'center' };
            }
        }

        const rigaInizioDati = headerRow.number + 1;

        for (const el of elencoContabili) {
            ws.addRow([
                dataDaTimestamp(el.data, 'testo'),
                el.causale,
                el.preventivo,
                el.consuntivo,
                el.fattura
            ]);
        }

        const rigaFineDati = ws.rowCount;

        // Bordo sottile grigio 35% tra le righe contabili (tranne sotto l'ultima) - esteso sempre per tutte e 5 le colonne
        for (let r = rigaInizioDati; r < rigaFineDati; r++) {
            const row = ws.getRow(r);
            for (let col = 1; col <= 5; col++) {
                const cell = row.getCell(col);
                cell.border = { bottom: { style: 'thin', color: { argb: 'FFA6A6A6' } } };
            }
        }

        ws.addRow([]);

        const rowTotale = ws.addRow([
            '',
            'Totale IVA esclusa',
            { formula: `SUM(C${rigaInizioDati}:C${rigaFineDati})` },
            { formula: `SUM(D${rigaInizioDati}:D${rigaFineDati})` },
            { formula: `SUM(E${rigaInizioDati}:E${rigaFineDati})` }
        ]);
        for (let col = 1; col <= 5; col++) {
            const cell = rowTotale.getCell(col);
            cell.font = { bold: true };
            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } } };
        }

        ws.addRow([]);

        const rowRimane = ws.addRow([
            '',
            'Rimane da fatturare',
            null,
            null,
            { formula: `D${rowTotale.number}-E${rowTotale.number}` }
        ]);
        for (let col = 1; col <= 5; col++) {
            const cell = rowRimane.getCell(col);
            cell.font = { bold: true };
        }

        // Impostazione della larghezza delle colonne
        ws.columns = [
            { width: 12 }, // A: Data
            { width: 40 }, // B: Causale
            { width: 12 }, // C: Preventivo
            { width: 12 }, // D: Consuntivo
            { width: 12 }  // E: Fattura
        ];

        // Applicazione della formattazione agli importi
        for (let r = rigaInizioDati; r <= ws.rowCount; r++) {
            const row = ws.getRow(r);
            [3, 4, 5].forEach(col => {
                const cell = row.getCell(col);
                if (cell && cell.value !== null && cell.value !== '') {
                    cell.numFmt = '#,##0.00';
                }
            });
        }

        // Creazione del file
        const buffer = await wb.xlsx.writeBuffer();
        const filename = leggiInfoDBRaw(elencoContabili[0]).stringaCliente + '.xlsx';

        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        URL.revokeObjectURL(link.href);

        return 1;
    }
}

export function scaricaXlsxCosti(elencoCosti, lavoroSingolo) {
    if (elencoCosti.length <= 0) {
        return 0;
    } else {
        let nomeFile = '';
        let data
        let nRigheIntestazione = 0;
        if (lavoroSingolo) {
            // Dati della tabella per lavoroSingolo
            data = [
                ['Data: ' + dataCorrente()],
                ['Cliente: ' + leggiInfoDBRaw(elencoCosti[0]).stringaCliente],
                ['Lavoro: ' + leggiInfoDBRaw(elencoCosti[0]).stringaLavoroCorta],
                [],
                ['Data', 'Descrizione', 'Lavoratore', 'Ore', 'Fornitore', 'Documento', 'Costo', 'Prezzo', 'Extra', 'Note']
            ];
            nRigheIntestazione = data.length;
            for (const el of elencoCosti) {
                data.push([dataDaTimestamp(el.data, 'testo'), el.descrizione, el.lavoratore, el.ore, el.fornitore, el.documento, el.costo, el.ore * impostazioniGenerali.value.prezzoManodopera + el.costo * (1 + impostazioniGenerali.value.ricaricoGenerale), el.extra ? 'X' : '', el.note]);
            }
            data.push([]);
            data.push(['Totale IVA esclusa', null, null,
                { t: 'n', f: 'SUM(D' + (nRigheIntestazione + 1) + ':D' + (data.length) + ')' },
                null, null,
                { t: 'n', f: 'SUM(G' + (nRigheIntestazione + 1) + ':G' + (data.length) + ')' },
                { t: 'n', f: 'SUM(H' + (nRigheIntestazione + 1) + ':H' + (data.length) + ')' },
            ]);
            data.push([]);
            data.push(['Prezzo unitario manodopera', null, impostazioniGenerali.value.prezzoManodopera]);
            data.push(['Ricarico materiali', null, impostazioniGenerali.value.ricaricoGenerale]);
            data.push(['Prezzo manodopera', null, { t: 'n', f: 'D' + (data.length - 3) + '*C' + (data.length - 1) }]);
            data.push(['Prezzo materiali', null, { t: 'n', f: 'G' + (data.length - 4) + '*(1+C' + (data.length - 1) + ')' }]);
            data.push(['Prezzo totale IVA esclusa', null, { t: 'n', f: 'C' + (data.length - 1) + '+C' + (data.length) }]);
            nomeFile = 'Costi generali' + '.xlsx'
            nomeFile = leggiInfoDBRaw(elencoCosti[0]).stringaCliente + ' - Costi' + '.xlsx'
        } else {
            // Dati della tabella per costi da lavori diversi
            data = [
                ['COSTI\n GENERALI'],
                [],
                ['Data: ' + dataCorrente()],
                [],
                ['Data', 'Lavoro', 'Descrizione', 'Lavoratore', 'Ore', 'Fornitore', 'Documento', 'Costo', 'Extra', 'Note']
            ];
            nRigheIntestazione = data.length;
            for (const el of elencoCosti) {
                data.push([dataDaTimestamp(el.data, 'testo'), leggiInfoDBRaw(el).stringaLavoro, el.descrizione, el.lavoratore, el.ore, el.fornitore, el.documento, el.costo, el.extra ? 'X' : '', el.note]);
            }
            data.push([]);
            data.push(['Totale IVA esclusa', null, null, null,
                { t: 'n', f: 'SUM(E' + (nRigheIntestazione + 1) + ':E' + (data.length) + ')' },
                null, null,
                { t: 'n', f: 'SUM(H' + (nRigheIntestazione + 1) + ':H' + (data.length) + ')' },
            ]);
            data.push([]);
            data.push(['Prezzo unitario manodopera', null, impostazioniGenerali.value.prezzoManodopera]);
            data.push(['Ricarico materiali', null, impostazioniGenerali.value.ricaricoGenerale]);
            data.push(['Prezzo manodopera', null, { t: 'n', f: 'E' + (data.length - 3) + '*C' + (data.length - 1) }]);
            data.push(['Prezzo materiali', null, { t: 'n', f: 'H' + (data.length - 4) + '*(1+C' + (data.length - 1) + ')' }]);
            data.push(['Prezzo totale IVA esclusa', null, { t: 'n', f: 'C' + (data.length - 1) + '+C' + (data.length) }]);
            nomeFile = 'Costi generali' + '.xlsx'
        }

        // Creazione del foglio di lavoro
        // const XLSX = require('xlsx');
        const XLSX = require('xlsx-js-style');
        const ws = XLSX.utils.aoa_to_sheet(data);

        if (lavoroSingolo) {
            // Impostazione della larghezza delle colonne
            ws['!cols'] = [
                { width: 11 }, // Larghezza della colonna Data
                { width: 30 }, // Larghezza della colonna Descrizione
                { width: 20 },  // Larghezza della colonna Lavoratore
                { width: 5 },  // Larghezza della colonna Ore
                { width: 20 },  // Larghezza della colonna Fornitore
                { width: 20 },  // Larghezza della colonna Documento
                { width: 10 },  // Larghezza della colonna Costo
                { width: 10 },  // Larghezza della colonna Prezzo
                { width: 5 },  // Larghezza della colonna Extra
                { width: 20 }  // Larghezza della colonna Note
            ];

            // Applicazione della formattazione agli importi
            for (let row = nRigheIntestazione + 1; row <= data.length; row++) {
                for (const col of ['G', 'H']) {
                    const cellAddress = col + `${row}`;
                    const cell = ws[cellAddress];
                    if (cell) {
                        cell.t = 'n';
                        cell.z = '#,##0.00';
                    }
                }
            }
            // Formattazione totali
            for (let row = data.length - 5; row <= data.length; row++) {
                for (const col of ['C']) {
                    const cellAddress = col + `${row}`;
                    const cell = ws[cellAddress];
                    if (cell) {
                        cell.t = 'n';
                        cell.z = '#,##0.00';
                    }
                }
            }
        } else {
            // Impostazione della larghezza delle colonne
            ws['!cols'] = [
                { width: 11 }, // Larghezza della colonna Data
                { width: 50 }, // Larghezza della colonna Lavoro
                { width: 30 }, // Larghezza della colonna Descrizione
                { width: 20 },  // Larghezza della colonna Lavoratore
                { width: 5 },  // Larghezza della colonna Ore
                { width: 20 },  // Larghezza della colonna Fornitore
                { width: 20 },  // Larghezza della colonna Documento
                { width: 10 },  // Larghezza della colonna Costo
                { width: 5 },  // Larghezza della colonna Extra
                { width: 20 }  // Larghezza della colonna Note
            ];

            // Applicazione della formattazione agli importi
            for (let row = nRigheIntestazione + 1; row <= data.length; row++) {
                for (const col of ['H']) {
                    const cellAddress = col + `${row}`;
                    const cell = ws[cellAddress];
                    if (cell) {
                        cell.t = 'n';
                        cell.z = '#,##0.00';
                    }
                }
            }
            // Formattazione totali
            for (let row = data.length - 5; row <= data.length; row++) {
                for (const col of ['C']) {
                    const cellAddress = col + `${row}`;
                    const cell = ws[cellAddress];
                    if (cell) {
                        cell.t = 'n';
                        cell.z = '#,##0.00';
                    }
                }
            }
        }

        // Creazione del libro di lavoro
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Contabilità');

        // Creazione del blob
        XLSX.writeFile(wb, nomeFile, { bookType: 'xlsx', bookSST: false, type: 'file', cellStyles: true });

        return 1;
    }
}

export function clonaOggetto(obj) {
    // Clona un oggetto

    // Ciclo in tutte le proprietà dell'oggetto e le copio in un nuovo oggetto
    let tempObj = {};
    for (let prop in toRaw(obj)) {
        // Se è un oggetto annidato ciclo tra le sue proprietà e le copio
        if (obj[prop] && typeof obj[prop].seconds === 'number' && typeof obj[prop].nanoseconds === 'number') {
            tempObj[prop] = new Timestamp(obj[prop].seconds, obj[prop].nanoseconds);
        } else if (obj[prop] === null) {
            tempObj[prop] = null;
        } else if (typeof obj[prop] === 'object') {
            tempObj[prop] = clonaOggetto(toRaw(obj)[prop]);
        } else {
            tempObj[prop] = toRaw(obj)[prop];
        }
    }
    return tempObj;
}

export function arrotonda(valore, decimali) {
    // Arrotonda un numero a n decimali
    let tempValore = 0;
    if (valore != null && valore != 0 && !isNaN(valore)) {
        tempValore = Math.round(valore * Math.pow(10, decimali)) / Math.pow(10, decimali);
    }
    return tempValore;
}

export function prezzoVocePreventivo(vocePrev, valoreRicSc) {
    // Restituisce il prezzo unitario della vocePrev passata

    let tempPrezzo = 0;
    if (valoreRicSc.fonte == 'Costo') {
        tempPrezzo = costoVocePreventivo(vocePrev);
    } else {
        if ('prListino' in vocePrev) {
            tempPrezzo = vocePrev.prListino;
        } else {
            tempPrezzo = vocePrev.prListinoVen;
        }
    }
    // Applico lo sconto prendendo le aliquote da valoreRicSc
    tempPrezzo = tempPrezzo * (1 + valoreRicSc.aliquote[0]) * (1 + valoreRicSc.aliquote[1]);
    return arrotonda(tempPrezzo, 2);
}

export function costoVocePreventivo(vocePrev) {
    // Restituisce il costo unitario della vocePrev passata
    let tempCosto = 0;
    if ('prListino' in vocePrev) {
        tempCosto = vocePrev.prListino;
    } else {
        tempCosto = vocePrev.prListinoAcq;
    }
    if (vocePrev.rcAcq) {
        tempCosto = tempCosto * (1 + vocePrev.rcAcq[0]) * (1 + vocePrev.rcAcq[1]) * (1 + vocePrev.rcAcq[2]);
    }
    return arrotonda(tempCosto, 2);
}

export function formattaTelefono(numero) {
    if (!numero) return "";

    // Togli spazi e caratteri non numerici (tranne +)
    numero = numero.replace(/[^\d+]/g, "");

    // Verifica che inizi con +, altrimenti non aggiunge prefisso
    const prefisso = numero.startsWith("+") ? numero.slice(0, 3) : "";
    let resto = numero.startsWith("+") ? numero.slice(3) : numero;

    // Spezza il resto in gruppi: 3 - 3 - 2 - 2
    const gruppi = [];
    if (resto.length > 0) gruppi.push(resto.slice(0, 3));
    if (resto.length > 3) gruppi.push(resto.slice(3, 6));
    if (resto.length > 6) gruppi.push(resto.slice(6, 8));
    if (resto.length > 8) gruppi.push(resto.slice(8, 10));

    // Unisce con spazi ignorando i gruppi vuoti
    return [prefisso, ...gruppi].filter(Boolean).join(" ");
}

/**
 * Estrae e normalizza un valore per permettere un ordinamento perfetto 
 * tra dati Caldi (Firestore Proxy) e Freddi (JSON markRaw).
 * * @param {Object} elemento L'oggetto (cliente, lavoro, lead)
 * @param {String} campo Il nome della proprietà da leggere (es. 'created', 'stringaCliente')
 * @param {Boolean} daInfo Se true, cerca il campo dentro leggiInfoDB(elemento)
 */
export function getValorePerOrdinamento(elemento, campo, daInfo = false) {
    // 1. Estrazione sicura del dato
    let valore = null;
    if (daInfo) {
        const info = leggiInfoDB(elemento);
        valore = info ? info[campo] : null;
    } else {
        valore = elemento[campo];
    }

    // 2. Fallback per valori mancanti (evita crash nel confronto)
    if (valore === null || valore === undefined) {
        return ''; // Le stringhe vuote o gli zeri finiranno in fondo/cima
    }

    // 3. NORMALIZZAZIONE DATE (Il fix fondamentale)
    // Riconosce Timestamp Firestore, Date JS, o JSON Storage
    if (valore instanceof Date) {
        return valore.getTime();
    }
    if (typeof valore.toDate === 'function') {
        return valore.toDate().getTime(); // È un dato Caldo Firestore
    }
    if (valore.seconds !== undefined) {
        return valore.seconds * 1000; // È un dato Freddo Storage JSON
    }

    // 4. NORMALIZZAZIONE STRINGHE
    if (typeof valore === 'string') {
        return valore.toLowerCase().trim();
    }

    // 5. Ritorno diretto per Numeri e Booleani
    return valore;
}